export default __webpack_public_path__ + "static/media/auth_bg.a07ea19c.jpg";